import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { BreadcrumbsContext } from './breadcrumbsContext';

export const BreadcrumbsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [breadcrumb, setBreadcrumb] = useState<ReactNode | null>(null);

  const clearBreadcrumb = useCallback(() => {
    setBreadcrumb(null);
  }, []);

  const contextValue = useMemo(
    () => ({
      breadcrumb,
      setBreadcrumb,
      clearBreadcrumb,
    }),
    [breadcrumb, setBreadcrumb, clearBreadcrumb]
  );

  return (
    <BreadcrumbsContext.Provider value={contextValue}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
